module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_txt01_02-dc7f2bee1f76ad472f25498a9828fc6c.webp";